import { Directive, Input } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import {  Observable, of, } from 'rxjs';
import { map, catchError} from 'rxjs/operators';

import { InputCheckersService } from '../all-services';
import { InseeEtablissement } from '../all-models';

@Directive({
  selector: '[siretValidator]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, useExisting: SiretValidatorDirective, multi:
      true
  }]
})
export class SiretValidatorDirective implements AsyncValidator {

  constructor(private inputCheckerSvc: InputCheckersService) { }

  @Input() supplierId?: number;

  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {
    // if (control?.parent?.get('agencySiret')!=null){
    //   console.log('agencySiret validator')
    // }
    const siret = (<string>control.value || '').replace(/\s/g, '');
    if ((control.value || 'null') == 'null') return of(null);
    if (!this.inputCheckerSvc.isSiret( control.value)) {
      return of({ 'longueurSiret': 'Msg_Siret_Incomplet' });
    }
    let getEtbsFn: Observable<InseeEtablissement> = this.inputCheckerSvc.getInseeEtablissement(siret);
    if (this.supplierId) {
      getEtbsFn = this.inputCheckerSvc.getSupplierInseeEtablissement(this.supplierId, siret);
    }

    return getEtbsFn
      .pipe(
        map((inseeEtab: InseeEtablissement) => {
          if (!inseeEtab) {
            return { 'SiretIntrouvable': 'Siret_inexistant' };
          } else {
            if (<string>control.value != siret) control.setValue(siret);
            return null;
          }
        }),
        catchError((error) => {
          return of({ 'ErreurSiret': error.message });
        })
      );
  }

  registerOnValidatorChange?(fn: () => void): void {
    //throw new Error('Method not implemented.');
  }

}